import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ActionLink from '../../components/ActionLink';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import YesNoDialog from '../../components/YesNoDialog';
import GroupModel from '../../model/GroupModel';
import AccountService from '../../services/AccountService';
import FileUploadService from '../../services/FileUploadService';
import GroupService from '../../services/GroupService';
import MobileUserService from '../../services/MobileUserService';
import SettingService from '../../services/SettingService';
import UserRoleService from '../../services/UserRoleService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import constants from '../../utils/constants';
import StringUtils from '../../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import { Column, DataTable, Message, TabPanel, TabView } from 'primereact';
import { Panel } from 'primereact/panel';
import UserLocations from './UserLocations';
import LocationsComponentV2 from '../../components/locations/LocationComponentV2';
import SimpleReactValidator from '../../components/validator';
import moment from 'moment';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import InputCalendarRangeComponent2 from '../../components/inputs/InputCalendarRangeComponent2';
import ActionButton from '../../components/ActionButton';


class MobileUserDetailsContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new MobileUserService());
        this.demoMode = process.env.REACT_APP_DEMO_MODE === "true";
        this.fileUploadService = new FileUploadService();
        this.groupService = new GroupService();
        this.state = {
            element: {
                locations:[],                
            },
            tabIndex: 0,
            elementId: props.elementId,
            invitation: props.invitation,
            viewMode: this.props.viewMode,
            removeDialog: false,
            tableWithUsersVisible: false,
            showTableWithUsers: false,
            showConfirmRemoveDialog: false,
            activeIndex: 0,
            name: undefined,
            users: [],
            user: undefined,
            selectedUsers: [],
            globalFilterValue: '',
            loading: true,
            timeline: undefined,
            timelinePage: 0,
            timelineRows: 10,
            timelineDateStart: moment().startOf('month').toDate(),
            timelineDateEnd: moment().endOf('month').toDate(),
            customLocationCollapsed: true,
            challenges: undefined,
            challengesPage: 0,
            challengesRows: 10,
            showFinishChallengeDialog: false,
            challengeToFinish: undefined,
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.userRoleService = new UserRoleService();
        this.userService = new AccountService();
        this.initBeforeSetElement = this.initBeforeSetElement.bind(this);
        this.handleValidForm = this.handleValidForm.bind(this);
        this.handleDeleteRow = this.handleDeleteRow.bind(this);
        this.handleUserSelectionChange = this.handleUserSelectionChange.bind(this);
        this.handleUserSelectionChangeFromDropdown = this.handleUserSelectionChangeFromDropdown.bind(this);
        this.uploadIconHandler = this.uploadIconHandler.bind(this);
        this.handleRemoveAssignedUser = this.handleRemoveAssignedUser.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.actionTemplateToJoinGroupName = this.actionTemplateToJoinGroupName.bind(this);
        this.prepareValidOptionsList = this.prepareValidOptionsList.bind(this);                
        this.fetchTimeline = this.fetchTimeline.bind(this);        
        this.fetchUserChallenges = this.fetchUserChallenges.bind(this);
    }

    onSelect = (e) => {
        this.setState(
            {
                selectedFile: e.files[0],
            },
            () => {
                this.uploadHandler();
            }
        );
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    initBeforeSetElement() {
        const criteria = {
            groupIdExcluded: this.props.elementId,
            firstResult: 0,
            maxResults: constants.SC_MAX_RESULT,
            sortField: 'name',
            sortAsc: true,
            dateRange: [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
            timelineType: 'ALL',
        };
        this.setState({criteria});

        this.service
            .getList(criteria)
            .then((users) => {
                this.setState({users: users.content});
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
       this.fetchTimeline(criteria.dateRange, criteria.timelineType);
       this.fetchUserChallenges();
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, invitation} = this.state;
        this.beforeUpdateElement(viewMode, elementId, invitation);
    }

    beforeUpdateElement(viewMode, elementId, invitation) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, invitation)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    prepareFooterItems() {
        const { viewMode, editUrl } = this.props;
        const editHref = `${editUrl}/${this.state.element?.id}`;
        const { cancelUrl } = this.props;
        return [
            {
                label: t('global.save'),
                className: 'float-left save-user',
                id: 'saveNewUser',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(cancelUrl));
                },
                className: 'gray',
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && !this.state.element.invitation,
            },
            {
                label: t('mobileUser.unblock'),
                id: 'unblockUser',
                className: 'float-right gray',
                rendered: this.state.element?.status === 'BLOCKED',
                onClick: this.unblockAccount,
            },
            {
                label: t('mobileUser.block'),
                id: 'blockUser',
                className: 'float-right red',
                rendered: !this.demoMode && !this.state.element.invitation && (this.state.element?.status === 'ACTIVE'  || this.state.element?.status === 'CREATED') && this.props.viewMode == 'VIEW',
                onClick: this.blockAccount,
            },
        ];
    }
    blockAccount = () => {
        const { element } = this.state;
        const { detailsUrl } = this.props;
        const href = `${detailsUrl}/${this.props?.elementId}/${this.state.element.invitation}`;

        this.blockUi();
        this.service
            .blockAccount(this.state.element.id)
            .then(() => {
                this.persistMessage('success', '',t('user.saved'));
                this.handleGoToDetail(href);
            })
            .catch((err) => {
                this.persistMessage('error', '', "Błąd blokowania użytkownika");
                this.unblockUi();
            });
    };

    unblockAccount = () => {
        const { detailsUrl } = this.props;
        const href = `${detailsUrl}/${this.props?.elementId}/${this.state.element.invitation}`;
    
        this.blockUi();
        this.service
            .unblockAccount(this.state.element.id)
            .then(() => {
                this.persistMessage('success', '', t('user.saved'));
                this.handleGoToDetail(href);
            })
            .catch((err) => {
                this.persistMessage('error', '', "Błąd odblokowania użytkownika");
                this.unblockUi();
            });
    };

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                label: t('global.back'),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-left',
                rendered: true,
            },
        ];
    }

    handleDeleteRow(rowData) {
        return (
            <ActionLink
                className='p-link float-right'
                handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                variant='red'
                iconName='mdi-trash-can'
                iconSide='left'
                iconSize='xs'
                iconColor='red'
            />
        );
    }
    handleOpenRemoveDialog(e, idToRemove) {
        if (e) {
            e.preventDefault();
        }
        this.setState({removeDialog: true, idToRemove});
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .remove(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('groups.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('groups.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        this.setState({
            showPublishDialog: true,
        });
    }

    getAddSucces() {
        return t('groups.createSuccess');
    }

    getUpdateSucces() {
        return t('groups.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        return element;
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('mobile-user.removeHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('mobile-user.deleteConfirmation')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.handleFinishChallengeConfirm}
                    visible={this.state.showFinishChallengeDialog}
                    header={t('mobileUser.challenges.finishHeader')}
                    name='visible'
                    yesButtonVariant='red'
                    onHide={() => {
                        this.setState({ showFinishChallengeDialog: false, challengeToFinish: undefined });
                    }}
                >
                    <div>
                        <p>
                            {t('mobileUser.challenges.finishConfirmation', {
                                title: this.state.challengeToFinish?.title || '',
                            })}
                        </p>
                        <Message
                            severity='warn'
                            text={t('mobileUser.challenges.finishMonitoredInfo')}
                            className='w-full mt-2'
                        />
                    </div>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }

    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                this.unblockUi();
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.hideRemoveConfirmation();
            });
    }

    getContainerListName() {
        return 'mobile-user-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('mobile-user.name'), url: '/mobile-user-list'},
            this.props.viewMode === 'NEW' ? {name: t('mobileUser.creating'), url: ``} : {name: t('mobile-user.details'), url: ``},
        ];
    }

    handleGoToDetail(href, e) {
        this.blockUi();
        this.props.history.push(href); // używamy history.push zamiast window.location.href
    }


    handleGoBack(e) {
        this.blockUi();
        const {backUrl} = this.props;
        this.props.history.push(backUrl);
    }

    handleValidForm() {
        const { element } = this.state;
        const { detailsUrl } = this.props;
        const href = `${detailsUrl}/${this.props?.elementId}`;

        if (this.props.viewMode !== 'NEW') {
            if (this.state.element.iconTemporaryFileUrl !== null) {
                this.service
                    .update(this.props.elementId, element)
                    .then((res) => {
                        this.persistMessage('success', '',  t('user.saved'))
                        this.unblockUi();
                        this.handleGoToDetail(href);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                this.showErrorMessage(t('groups.avatarRequired'), 10000);
                this.unblockUi();
            }
        } else {
            this.service
                .create(element)
                .then(() => {
                    this.persistMessage('success', '',  "Pomyślnie dodano nowego użytkownika")
                    this.unblockUi();
                    this.handleGoBack();
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                    this.unblockUi();
                });
        }
    }
    handleUserSelectionChange(list) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: list,
            },
        }));
    }

    handleUserSelectionChangeFromDropdown(a, b, c, list) {
        const selectedUsers = this.state.element.users.filter((u) => u.email !== c.value.email);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: selectedUsers.concat(c.value),
            },
        }));
    }

    handleRemoveAssignedUser(element, e) {
        if (e) {
            e.preventDefault();
        }
        const modifiedList = this.state.element.users;
        const optionsList = this.state.users;
        let found = false;
        let indexOfRemoved = -1;
        if (modifiedList !== undefined && modifiedList.length > 0) {
            modifiedList.forEach((el, i) => {
                if (el['id'] === element['id']) {
                    found = true;
                    indexOfRemoved = i;
                    return;
                }
            });
        }
        modifiedList.splice(indexOfRemoved, 1);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                users: modifiedList,
            },
            users: optionsList,
        }));
    }

    uploadIconHandler(uploadedFile) {
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                iconTemporaryFileUrl: uploadedFile.uuid,
            },
        }));
    }

    actionTemplate(rowData) {
        const { t } = this.props;
        if (!rowData.action) return '';
        return t(`timeline.action.${rowData.action}`);
    }
    actionTemplateToJoinGroupName(item) {
        return (
            <div>
                <div>
                    {item.name}
                    {!StringUtils.isBlank(item.groupNames) ? ` ( ${t('groups.assignedTo')}  ${item.groupNames})` : ''}
                </div>
            </div>
        );
    }

    prepareValidOptionsList() {
        let selectedUsersId = this.state.element?.users.map((cu) => cu.id);
        return this.state?.users.filter((u) => !selectedUsersId?.includes(u.id));
    }

    avatarComponent() {
        const {viewMode} = this.props;
        if (viewMode === 'NEW') {
            return;
        }
        const uuid = this.state.element?.avatar?.fileUuid;
        const avatarPath = this.service.getPath() + `/${uuid}/avatar/current-user`;
        const img = StringUtils.isBlank(uuid) ? (
            ''
        ) : (
            <img
                src={`${avatarPath}?token=${this.authService.getToken()}`}
                // src={`https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/PNG_transparency_demonstration_1.png/220px-PNG_transparency_demonstration_1.png`}
                alt='Avatar'
                className='product-image col-12'
                style={{borderRadius: '50%', height: '70px', width: '90px'}}
            />
        );
        return img;
    }

    changeTab = (e) => {
        sessionStorage.setItem('tab-company-index', e.index);
        this.setState({
            tabIndex: e.index,
        });
    };

    renderDetails() {
        return (
            <div>
                {this.state.element.invitation ? (
                    <Message severity="info" text={t('mobileUser.user-invitation')} 
                        style={{
                            borderWidth: '0 0 0 6px',
                            background: '#5637c2',
                            color: '#d5ceee'
                        }}
                        icon={<i className="pi pi-info-circle" style={{ color: '#d5cee', marginRight: '8px' }} />} 
                        className="border-primary w-full justify-content-start"
                    />
                ) : <span/>}

                <div className='row'>
                   
                        <InputTextComponent
                            id='email'
                            name='email'
                            label={t('mobileUser.email')}
                            colClass='col-md-4'
                            value={this.state.element?.email}
                            validator={this.validator}
                            validators='required|max:50'
                            disabled={this.props.viewMode !== 'NEW'}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                        />
                        <InputTextComponent
                            id='firstName'
                            name='firstName'
                            label={t('mobileUser.firstName')}
                            colClass='col-md-4'
                            value={this.state.element?.firstName}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            disabled={this.props.viewMode !== 'NEW' && this.props.viewMode !== 'EDIT'}
                        />
                        <InputTextComponent
                            id='lastName'
                            name='lastName'
                            label={t('mobileUser.lastName')}
                            colClass='col-md-4'
                            value={this.state.element?.lastName}
                            validator={this.validator}
                            validators='required|max:50'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            disabled={this.props.viewMode !== 'NEW' && this.props.viewMode !== 'EDIT'}
                        />
                        
                   
                    
                </div>
                <div className='row'>
                <div className='col-md-4'>
                    {this.props.viewMode !== 'NEW' && (
                            <InputCheckboxComponent
                                id='canViewDraft'
                                name='canViewDraft'
                                label={t('mobileUser.canViewDraft')}
                                validators='not_required'
                                colClass='col-12'
                                value={this.state.element?.canViewDraft}
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                                disabled={this.state.element?.status != 'ACTIVE' && this.state.element?.status != 'CREATED'}
                            />
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-4'>
                        <InputNumberComponent
                            colClass={'col-12'}
                            validators='not_required'
                            maxFractionDigits={2}
                            label={
                                <div>
                                    <i className='mdi mdi-wallet base-color' style={{ fontSize: '20px' }} />
                                    <label className='p-label'>{t('mobileUser.moneyActual')}</label>
                                </div>
                            }
                            value={this.state.element?.moneyActual}
                            viewMode={this.props.viewMode}
                            disabled={true}
                            rendered={this.props.viewMode !== 'NEW'}
                        />
                    </div>
                    <div className='col-md-4'>
                        <InputNumberComponent
                            colClass={'col-12'}
                            validators='not_required'
                            maxFractionDigits={2}
                            label={
                                <div>
                                    <i className='mdi mdi-piggy-bank base-color' style={{ fontSize: '20px' }} />
                                    <label className='p-label'> {t('mobileUser.moneyTotal')}</label>
                                </div>
                            }
                            value={this.state.element?.moneyTotal}
                            viewMode={this.props.viewMode}
                            disabled={true}
                            rendered={this.props.viewMode !== 'NEW'}
                        />
                    </div>
                </div>
               {this.props.viewMode === 'VIEW' && (
               <div className='mt-5'>
                <h4>
                  {t('timeline.userPointsHistory')}
                  <span style={{ fontWeight: 'normal', fontSize: '1rem', marginLeft: 8 }}>({t('timeline.inThisCompany')})</span>
                </h4>
                <div className='row mb-3'>
               
                <div className="row mb-3 align-items-end gx-3">
                  <div className="col-auto">
                    <InputDropdownComponent
                      viewMode='EDIT'
                      id='timelineType'
                      name='timelineType'
                      label={t('timeline.action-type')}
                      value={this.state.criteria.timelineType}
                      validators='not_required'
                      optionLabel='label'
                      dataKey='value'
                      options={[
                        { label: t('timeline.action.ALL'), value: 'ALL' },
                        { label: t('timeline.action.MESSAGE'), value: 'MESSAGE' },
                        { label: t('timeline.action.CHALLENGE'), value: 'CHALLENGE' },
                        { label: t('timeline.action.TRANSPORT'), value: 'TRANSPORT' },
                        { label: t('timeline.action.SURVEY'), value: 'SURVEY' },
                        { label: t('timeline.action.STANDARD'), value: 'STANDARD' },
                        { label: t('timeline.action.ACTION'), value: 'ACTION' },
                      ]}
                      enumMode={true}
                      onChange={this.handleChangeSc}
                      colClass='col-auto'
                    />
                  </div>
                  <div className="col-2 ">
                    <InputCalendarRangeComponent2
                      validators='required'
                      id="dateRange"
                      name="dateRange"
                      label={t('event.dateRange')}
                      colClass="col-12"
                      value={this.state.criteria.dateRange}
                      validator={this.validator}
                      onChange={this.handleChangeSc}
                      viewMode="EDIT"                      
                      showIcon
                      placeholder="dd-mm-rrrr - dd-mm-rrrr"
                      validateViewMode
                      dateFormatMoment="DD-MM-YYYY"
                    />
                    </div>
                    <div className="col-auto mb-1">
                    <ActionButton
                        id='importMobileUsers'
                        label={t('global.filter')}
                        iconSide='left'
                        handleClick={this.handleSearch}
                    />
</div>
                </div>
                </div>
                <div className='row'>
                <DataTable
                        emptyMessage={t('list.empty')}
                        value={this.state.timeline?.content}                                
                        removableSort
                        tableStyle={{minWidth: '50rem'}}
                        paginator
                        lazy={true}
                        first={this.state.timelinePage * this.state.timelineRows}
                        rows={this.state.timelineRows}
                        totalRecords={this.state.timeline?.totalElements || 0}
                        onPage={this.onTimelinePage}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                    >
                        <Column field='action' header={t('timeline.action-type')} body={this.actionTemplate} footer='Podsumowanie:'/>
                        <Column field='title' header={t('timeline.title')} body={this.titleTemplate} />
                        <Column field='amount' header={t('timeline.amount')} footer={this.state.summary?.amount} />
                        <Column field='totalDistance' header={t('timeline.details.totalDistance')} />
                        <Column field='direction' header={t('timeline.details.direction')}
                            body={this.directionTemplate} />
                        <Column field='workRelatedTravel' header={t('timeline.details.workRelatedTravel')}
                            body={rowData => rowData.workRelatedTravel ? t('global.yes') : t('global.no')} />
                        <Column field='date' header={t('timeline.date')}
                            body={this.dateTemplate} />
                        
                    </DataTable>
                </div>
                </div>
                )}
                {this.props.viewMode === 'VIEW' && (
                    <div className='mt-5'>
                        <h4>{t('mobileUser.challenges.title')}</h4>
                        <div className='row'>
                            <DataTable
                                emptyMessage={t('list.empty')}
                                value={this.state.challenges?.content}
                                removableSort
                                tableStyle={{ minWidth: '50rem' }}
                                paginator
                                lazy={true}
                                first={this.state.challengesPage * this.state.challengesRows}
                                rows={this.state.challengesRows}
                                totalRecords={this.state.challenges?.totalElements || 0}
                                onPage={this.onChallengesPage}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                            >
                                <Column field='title' header={t('challenge.title')} body={this.challengeTitleTemplate} />
                                <Column field='coinsToEarn' header={t('challenge.coinsToEarn')} />
                                <Column field='progress' header={t('mobileUser.challenges.progress')} body={this.challengeProgressTemplate} />
                                <Column field='status' header={t('mobileUser.challenges.status')} body={this.challengeStatusTemplate} />
                                <Column field='joinDate' header={t('mobileUser.challenges.joinDate')} body={(row) => this.dateTemplate(row, { field: 'joinDate' })} />
                                <Column field='finishDate' header={t('mobileUser.challenges.finishDate')} body={(row) => this.dateTemplate(row, { field: 'finishDate' })} />
                                <Column field='activeFrom' header={t('challenge.activeFrom')} body={(row) => this.dateTemplate(row, { field: 'activeFrom' })} />
                                <Column field='activeTo' header={t('challenge.activeTo')} body={(row) => this.dateTemplate(row, { field: 'activeTo' })} />
                                <Column header={t('mobileUser.challenges.actions')} body={this.challengeActionTemplate} style={{ width: '12rem' }} />
                            </DataTable>
                        </div>
                    </div>
                )}
                <div className='row'>
                    <div className='col-12 mt-4 mb-4'>
                        <Panel
                            header={t('global.customLocation') || 'Lokalizacja niestandardowa'}
                            collapsed={this.state.customLocationCollapsed}
                            toggleable
                            onToggle={(e) => this.setState({ customLocationCollapsed: e.value })}
                        >
                            <Message
                                severity='info'
                                text={'Ustawienie lokalizacji użytkownika nie jest wymagane. Jest potrzebne, jeśli pracownikowi zaliczamy przejazdy (np. rowerem) do innego miejsca np. dworca PKP — wtedy ustaw lokalizację tego miejsca.'}
                                className='mb-3'
                            />
                            {!this.state?.companyLocationsLoading && (
                                <LocationsComponentV2
                                    initLocation={[52.137, 19.317]}
                                    locations={this.state?.element?.locations}
                                    showErrorMessage={this.showErrorMessage}
                                    showSuccessMessage={this.showSuccessMessage}
                                    onAddLocation={(location) => {
                                        const locations = this.state.element.locations;
                                        locations.push(location);
                                        this.setState((prevState) => ({
                                            element: {
                                                ...prevState.element,
                                                locations,
                                            },
                                        }));
                                    }}
                                    viewMode={this.props.viewMode}
                                    validator={ new SimpleReactValidator({}, this.translate)}
                                    onUpdateLocation={(locations) => {
                                        this.setState((prevState) => ({
                                            element: {
                                                ...prevState.element,
                                                locations,
                                            },
                                        }));
                                    }}
                                />
                            )}
                        </Panel>
                    </div>
                </div>

            </div>
            
        );
    }

    onTimelinePage = (event) => {
        this.setState({
            timelinePage: event.page,
            timelineRows: event.rows,
        }, () => {
            this.fetchTimeline(this.state.criteria.dateRange, this.state.criteria.timelineType);
        });
    };

    dateTemplate = (rowData, column) => {
        const value = rowData[column.field];
        return value ? moment(value).format('YYYY-MM-DD HH:mm') : '';
    };

    directionTemplate = (rowData) => {
        const { t } = this.props;
        if (!rowData.direction) return '';
        return t(`timeline.direction.${rowData.direction}`);
    };

    titleTemplate = (rowData) => {
        if (rowData.title === 'STEPS') return 'Kroki';
        return rowData.title;
    };
    
  



    fetchTimeline = (dateRange, timelineType) => {
        if(this.props.viewMode !== 'VIEW') return;
        const [dateStart, dateEnd] = dateRange || [];
        this.service
        .getUserTimelineSummary(
            this.state.elementId,
            timelineType,
            dateStart ? moment(dateStart).format('YYYY-MM-DD') : undefined,
            dateEnd ? moment(dateEnd).format('YYYY-MM-DD') : undefined
        )
        .then((summary) => {
            this.setState({ summary });
        })
        .catch((err) => {
            this.showErrorMessage(err.message);
        });
        this.service
            .getUserTimeline(
                this.state.elementId,
                timelineType,
                this.state.timelinePage,
                this.state.timelineRows,
                dateStart ? moment(dateStart).format('YYYY-MM-DD') : undefined,
                dateEnd ? moment(dateEnd).format('YYYY-MM-DD') : undefined
            )
            .then((timeline) => {
                this.setState({ timeline });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    };

    handleSearch = () => {
        if (this.validator.allValid()) {
            this.fetchTimeline(this.state.criteria.dateRange, this.state.criteria.timelineType);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    fetchUserChallenges() {
        if (this.props.viewMode !== 'VIEW') return;
        this.service
            .getUserChallenges(this.state.elementId, this.state.challengesPage, this.state.challengesRows)
            .then((challenges) => {
                this.setState({ challenges });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    onChallengesPage = (event) => {
        this.setState(
            {
                challengesPage: event.page,
                challengesRows: event.rows,
            },
            () => {
                this.fetchUserChallenges();
            }
        );
    };

    challengeProgressTemplate = (rowData) => {
        const current = rowData?.currentValue ?? 0;
        const goal = rowData?.goalValue ?? 0;
        const isDistance = rowData?.measureUnit === 'DISTANCE';
        const unit = isDistance ? 'km' : '';
        const format = (v) => (isDistance ? (Number(v) / 1000).toFixed(2) : v);
        return `${format(current)} / ${format(goal)}${unit ? ' ' + unit : ''}`;
    };

    challengeStatusTemplate = (rowData) => {
        return rowData?.status?.statusLabel || '';
    };

    challengeTitleTemplate = (rowData) => {
        return rowData?.title;
    };

    handleOpenFinishChallengeDialog = (e, rowData) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({
            showFinishChallengeDialog: true,
            challengeToFinish: rowData,
        });
    };

    handleFinishChallengeConfirm = (type, costam, target) => {
        if (target.value) {
            const challenge = this.state.challengeToFinish;
            if (!challenge) {
                this.setState({ showFinishChallengeDialog: false });
                return;
            }
            this.blockUi();
            this.service
                .finishUserChallenge(this.state.elementId, challenge.id)
                .then(() => {
                    this.persistMessage('success', '', t('mobileUser.challenges.finishSuccess'));
                    this.setState(
                        { showFinishChallengeDialog: false, challengeToFinish: undefined },
                        () => {
                            this.fetchUserChallenges();
                            this.unblockUi();
                        }
                    );
                })
                .catch((err) => {
                    this.setState({ showFinishChallengeDialog: false, challengeToFinish: undefined });
                    this.showErrorMessage(err?.message || t('mobileUser.challenges.finishError'));
                    this.unblockUi();
                });
        } else {
            this.setState({ showFinishChallengeDialog: false, challengeToFinish: undefined });
        }
    };

    challengeActionTemplate = (rowData) => {
        const isFinished = rowData?.status?.status === 'FINISHED';
        if (isFinished || this.demoMode) {
            return '';
        }
        return (
            <ActionLink
                className='p-link'
                handleClick={(e) => this.handleOpenFinishChallengeDialog(e, rowData)}
                variant='blue'
                iconName='mdi-flag-checkered'
                iconSide='left'
                iconSize='xs'
                label={t('mobileUser.challenges.finish')}
            />
        );
    };
}

MobileUserDetailsContainer.defaultProps = {
    backUrl: '/mobile-user-list',
    cancelUrl: '/mobile-user-list',
    editUrl: '/mobile-user/edit',
    detailsUrl: '/mobile-user/details',
    lazy: true,
    invitation: false
};

MobileUserDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    afterSave: PropTypes.func,
    invitation: PropTypes.bool
};

export default withRouter(withTranslation()(MobileUserDetailsContainer));
